import {formatCurrency} from '../../../utils';
import ItemBadge from './ItemBadge';
import AccountLabel from '../../../components/common/AccountLabel';
import useScreenSize from '../../../hooks/useScreenSize';

export const itemTitle = (item) => {
    if (item.type === 'TRANSFER') return item.title || 'Transfer';
    if (item.type === 'EXPENSE') return item.title || 'Expense';
    if (!item.movementDetails) return item.projectTitle || 'Income';

    const {type} = item.movementDetails;
    if (type === 'RATE_BASED') {
        const {rate, days, sharePercent} = item.movementDetails;
        return `${rate}/h × ${days}d${sharePercent < 100 ? ` × ${sharePercent}%` : ''}${item.projectTitle ? ` — ${item.projectTitle}` : ''}`;
    }
    if (type === 'REVALUATION') return 'Portfolio revaluation';
    return item.projectTitle || 'Fixed income';
};

export const itemMeta = (item, accountsById = {}, mobile = false) => {
    const isTransfer = item.type === 'TRANSFER';
    const resolvedAccount = accountsById[item.accountId];

    const From = (<AccountLabel
        account={{
            title: resolvedAccount?.title ?? item.accountTitle,
            sourceName: (isTransfer && mobile) ? '' : resolvedAccount?.sourceName,
        }}
        small={true}
    />);

    if (isTransfer) {
        const transferAccount = accountsById[item.transferAccountId];

        const To = (<AccountLabel
            account={{
                title: transferAccount?.title ?? item.accountTitle,
                sourceName: (isTransfer && mobile) ? '' : transferAccount?.sourceName,
            }}
            small={true}
        />);

        return (<>
            {From}{' → '}{To}
            <span>{item.notes && !mobile && ` · ${item.notes}`}</span>
        </>);
    }

    return (<>
        {From}
        <span>{item.notes && !mobile && ` · ${item.notes}`}</span>
    </>);
};

const TransactionItem = ({item, accountsById = {}, onEdit, onDelete}) => {
    const {isMobile, isCompact} = useScreenSize();
    return (
        <div className={`tx-item tx-item--${item.type.toLowerCase()}`}
             onClick={() => onEdit ? onEdit(item) : undefined}>
            <ItemBadge item={item}/>
            <div className="tx-item__main">
                <div className="tx-item__title">{itemTitle(item)}</div>
                <div className="tx-item__meta">{itemMeta(item, accountsById, isMobile)}</div>
            </div>
            <div className="tx-item__amount">
                {item.type === 'TRANSFER' ? (
                    <span className="tx-item__amount-gross transfer-value">
                        {formatCurrency(item.gross, item.currencyCode, isCompact)}
                        →
                        {formatCurrency(item.transferAmount, item.transferCurrencyCode, isCompact)}
                    </span>
                ) : (
                    <>
                        <span className={`tx-item__amount-gross ${item.type === 'INCOME' ? 'positive-value' : 'negative-value'}`}>
                            {item.type === 'INCOME' ? '+' : '−'}
                            {formatCurrency(item.gross, item.currencyCode)}
                        </span>
                        {item.type === 'INCOME' && item.net !== item.gross && (
                            <span className="tx-item__amount-net">
                                net {formatCurrency(item.net, item.currencyCode)}
                            </span>
                        )}
                    </>
                )}
            </div>
            {onDelete && <button
                className="btn-del"
                title="Delete"
                onClick={e => {
                    e.stopPropagation();
                    onDelete(item);
                }}>
                ×
            </button>}
        </div>
    );
};

export default TransactionItem;